import { User } from '../administration/user/user.models';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  vds?: string;
  expiresIn?: number;
  user?: User;
}

export interface AuthErrorType {
  title: string;
  message: string;
}

export interface AuthError {
  [key: string]: AuthErrorType;
}

export const ERRORS: AuthError = {
  USER_DOES_NOT_EXIST: {
    title: 'Error',
    message: 'Please Enroll or Activate your account.'
  },
  invalid_username_password: {
    title: 'Error',
    message: 'Incorrect Login Credentials, Please Try Again.'
  },
  USER_LOGGED_OUT: {
    title: 'Logged Out',
    message: 'You have been logged out successfully.'
  },
  USER_SESSION_EXPIRED: {
    title: 'Session Expired',
    message: 'You have been logged out successfully.'
  },
  LOGIN_AUTH_FAILURE: {
    title: 'Login Authentication Failure',
    message: 'Authentication failed as it took longer than expected, Please Try Again.'
  }
};

export interface ForgotPasswordRequest {
  email: string;
}
